import marked, {type Renderer as MarkedRenderer} from '@time-webkit/marked';

import {convertEntityToCharacter} from 'utils/text_formatting';

import RemoveMarkdown from 'utils/markdown/remove_markdown';

import type EmojiMap from 'utils/emoji_map';

import Renderer from './renderer';
import {customTimestampRenderer} from './custom_timestamp_renderer';

const removeMarkdown = new RemoveMarkdown();

export function format(text: string, options = {}, emojiMap?: EmojiMap) {
    return formatWithRenderer(
        text,
        new Renderer(
            {
                breaks: true,
            },
            options,
            emojiMap,
        ),
    );
}

export function formatWithRenderer(text: string, renderer: MarkedRenderer) {
    return marked.parse(stripImageLinks(formatCustomTimestamps(text)), {
        renderer,
        gfm: true,
        breaks: true,
        async: false,
    }).trim();
}

function stripImageLinks(text: string): string {
    return text.replace(
        /(?<!\\)!\[(.+)\]\((?!.*cdn-tinkoff\.ru|.*tinkoff\.ru|.*\/\/tcsbank\.ru|.*alert-images-mumbai\.s3\.amazonaws\.com|.*cardsmobile\.ru|.*tbank\.ru)(.+)\)/gm,
        '[$1]($2)',
    );
}

export function formatCustomTimestamps(text: string) {
    return text.replace(/<t:([0-9]*)(:([tdfTDFR]+))?>/, (_: string, timestamp: string, p2?: string, type?: string) => {
        return customTimestampRenderer(Number(timestamp) * 1000, type);
    });
}

export function stripMarkdown(text: string) {
    if (typeof text === 'string' && text.length > 0) {
        return convertEntityToCharacter(formatWithRenderer(text, removeMarkdown)).trim();
    }

    return text;
}
